<div class="contents-area" (dragstart)="onDragstartBody($event)">
  <div class="element-column">
    <div class="block-row">
      <div class="column-list">
        <label class="list-input-title">ユーザ区分</label>
        <div class="list-input-content">
          <select id="cmb_userType" #cmb_userType 
            [(ngModel)]="kymw9000Model.associatedUserType" forcedEnabledMode="'true'">
            <option value=""></option>
            <ng-template ngFor let-item [ngForOf]="kymw9000Model.associatedUserTypeList">
              <option value="{{item.associatedUserType}}">{{item.associatedUserTypeName}}</option>
            </ng-template>
          </select>
        </div>
      
        <label class="list-input-title">権限</label>
        <div class="list-input-content">
          <select id="select_authority" [(ngModel)]="kymw9000Model.authoritySetId" forcedEnabledMode="'true'">
            <option value=""></option>
            <ng-template ngFor let-item [ngForOf]="kymw9000Model.authoritySetList">
              <option value="{{item.authoritySetId}}">{{item.authoritySetName}}</option>
            </ng-template>
          </select>
        </div>
      </div>
      
      <div class="column-list">
        <label class="list-input-title">氏名</label>
        <div class="list-input-content">
          <app-text-input type="text" id="tbx_associatedUserName" [(ngModel)]="kymw9000Model.associatedUserName"
            [maxChars]="50" [displayCountField]="false" [restrict]="'[ -￮]'" forcedEnabledMode="true"></app-text-input>
        </div>
      
        <label class="list-input-title">所属</label>
        <div class="list-input-content">
          <app-text-input type="text" id="tbx_associatedCompanyName" [(ngModel)]="kymw9000Model.associatedCompanyName"
            [maxChars]="50" [displayCountField]="false" [restrict]="'[ -￮]'" forcedEnabledMode="true"></app-text-input>
        </div>
      </div>

      <div class="column-list">
        <label class="list-input-title">メールアドレス</label>
        <div class="list-input-content">
          <app-text-input type="text" id="tbx_emailAddress" [(ngModel)]="kymw9000Model.emailAddress"
            [maxChars]="50" [displayCountField]="false" [restrict]="'[ -￮]'" forcedEnabledMode="true"></app-text-input>
        </div>

        <label class="list-input-title">有効/無効</label>
        <div class="list-input-content">
          <select id="cmb_isEnabled" [(ngModel)]="kymw9000Model.isEnabled" forcedEnabledMode="true">
            <option value="99">すべて</option>
            <option value="0">有効のみ</option>
            <option value="1">無効のみ</option>
          </select>
        </div>
      </div>
    </div>

    <div style="width: 1623px;">
      <button class="btn-secondary" id="btn_display" 
        (click)="eventBtnDisplay_CLICKHandler(1)" forcedEnabledMode="true">表示</button>
      <div class="action-area">
        <app-pager [prevDisabled]="!kymw9000Model.btnBackEnabled" [nextDisabled]="!kymw9000Model.btnNextEnabled" [totalNum]="kymw9000Model.TotalNum"
          [startNum]="kymw9000Model.StartDispNum" [endNum]="kymw9000Model.EndDispNum" (prevHandler)="eventBackHandler()"
          (nextHandler)="eventNextHandler()">
        </app-pager>
      </div>
      <wj-flex-grid id="dgt_associatedUserManagementList" #dgt_associatedUserManagementList
        [itemsSource]="kymw9000Model.associatedUserManagementList" [allowDragging]="'None'" selectable="true"
        horizontalScrollPolicy="on" [isReadOnly]="true" forcedEnabledMode="true" [tabindex]="0">
        <wj-flex-grid-column [minWidth]="5" [width]="110" [header]="'ユーザ区分'" [binding]="'associatedUserTypeName'"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [width]="380" [header]="'氏名'" [binding]="'associatedUserName'"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [width]="380" [header]="'メールアドレス'" [binding]="'emailAddress'"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [width]="380" [header]="'権限'" [binding]="'authoritySetName'"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [width]="253" [header]="'所属'" [binding]="'associatedCompanyName'"></wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [width]="100" [header]="'有効/無効'" [binding]="'isEnabled'"></wj-flex-grid-column>
      </wj-flex-grid>
    </div>
  </div>
   
</div>
<footer class="footer-buttons">
  <button class="btn-primary" (click)="eventDgtAssociatedUserManagementListAdd_CLICKHandler()" 
    id="btn_regist" [disabled]="!kymw9000Model.btnRegistEnabled">新規登録</button>
</footer>